module.exports = __webpack_public_path__ + "static/media/FREEDOM-FREEDOM-LITE.2c486671.png";